import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteUserAvatarsService = async (userId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/avatars/users/${userId}`);
};

export default deleteUserAvatarsService;
